import React from 'react'

const Overview = ({ CoursesDetails }) => {
    // Technology & Future Trends specific content
    const getCourseContent = (title) => {
        if (title === 'Technology & Future Trends') {
            return {
                description: `Explore cutting-edge technologies and future trends that are shaping our world. This comprehensive course covers emerging technologies, digital transformation, artificial intelligence, blockchain, IoT, and other revolutionary innovations that will define the next decade.`,
                detailedDescription: `In this course, you'll dive deep into the technologies that are transforming industries and creating new opportunities. From artificial intelligence and machine learning to quantum computing and biotechnology, we'll explore how these technologies work, their current applications, and their potential future impact.`,
                whyChoose: `This course provides you with the knowledge and insights needed to understand and leverage emerging technologies in your career and business. You'll learn from industry experts and gain practical experience with cutting-edge tools and platforms.`,
                benefits: [
                    "Understand emerging technologies and their applications",
                    "Learn about AI, blockchain, IoT, and quantum computing",
                    "Explore future trends and their business implications",
                    "Gain insights into digital transformation strategies",
                    "Develop skills to identify and evaluate new technologies"
                ]
            };
        }
        // Default content for other courses
        return {
            description: CoursesDetails?.description || "Comprehensive course content designed to enhance your skills and knowledge.",
            detailedDescription: "This course provides in-depth knowledge and practical skills to help you succeed in your chosen field.",
            whyChoose: "This course offers excellent value with expert instruction and comprehensive content.",
            benefits: [
                "Expert instruction from industry professionals",
                "Comprehensive curriculum covering all essential topics",
                "Practical hands-on experience and real-world applications",
                "Flexible learning schedule to fit your lifestyle",
                "Certificate of completion upon successful finish"
            ]
        };
    };

    const content = getCourseContent(CoursesDetails?.title);

    return (
        <div className="wpo-course-content">
            <div className="wpo-course-text-top">
                <h2>{CoursesDetails?.title || 'Course Overview'}</h2>
                <div className="course-b-text">
                    <p>{content.description}</p>
                    <p>{content.detailedDescription}</p>
                    <p>Our expert instructors bring years of industry experience to help you understand complex concepts through practical examples and real-world case studies.</p>
                </div>
                <div className="course-bb-text">
                    <h3>Why Choose This Course</h3>
                    <p>{content.whyChoose}</p>
                    <ul>
                        {content.benefits.map((benefit, index) => (
                            <li key={index}>{benefit}</li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default Overview;